import demoImg from "../assets/images/demo_cpu.png";

function createData(
  part_number,
  sub_category,
  description,
  manufacturer,
  price,
  details
) {
  return {
    part_number,
    sub_category,
    description,
    manufacturer,
    price,
    details: details,
  };
}

export const rows = [
  createData(
    "STM32H71250VBT6",
    "mcu",
    "	ic mcu 32bit 1MB flash 144 lqfp",
    "stmicroelectronics",
    4.0,
    {
      image: demoImg,
      features: [
        { title: "core processor", type: "arm" },
        { title: "core processor", type: "arm" },
        { title: "core processor", type: "arm" },
        { title: "core processor", type: "arm" },
      ],
    }
  ),

  createData(
    "STM32H750VBT6",
    "mcu",
    "	ic mcu 32bit 1MB flash 144 lqfp",
    "stmicroelectronics",
    12,
    {
      image: demoImg,
      features: [
        { title: "core processor", type: "arm" },
        { title: "core processor", type: "arm" },
        { title: "core processor", type: "arm" },
        { title: "core processor", type: "arm" },
      ],
    }
  ),

  createData(
    "STM32H7150VBT6",
    "mcu",
    "	ic mcu 32bit 1MB flash 144 lqfp",
    "stmicroelectronics",
    11,
    {
      image: demoImg,
      features: [
        { title: "core processor-21", type: "arm" },
        { title: "core processor-11", type: "aet" },
        { title: "core processor-1", type: "tes" },
        { title: "core processor-00123", type: "cpu" },
      ],
    }
  ),

  createData(
    "STM32H75023VBT6",
    "mcu",
    "	ic mcu 32bit 1MB flash 144 lqfp",
    "stmicroelectronics",
    11,
    {
      image: demoImg,
      features: [
        { title: "core processor-21", type: "arm" },
        { title: "core processor-11", type: "aet" },
        { title: "core processor-1", type: "tes" },
        { title: "core processor-00123", type: "cpu" },
      ],
    }
  ),
  createData(
    "STM32H750VBT6",
    "mcu",
    "	ic mcu 32bit 1MB flash 144 lqfp",
    "stmicroelectronics",
    11,
    {
      image: demoImg,
      features: [
        { title: "core processor-21", type: "arm" },
        { title: "core processor-11", type: "aet" },
        { title: "core processor-1", type: "tes" },
        { title: "core processor-00123", type: "cpu" },
      ],
    }
  ),
  createData(
    "STM32H750VB99T6",
    "mcu",
    "	ic mcu 32bit 1MB flash 144 lqfp",
    "stmicroelectronics",
    11,
    {
      image: demoImg,
      features: [
        { title: "core processor-21", type: "arm" },
        { title: "core processor-11", type: "aet" },
        { title: "core processor-1", type: "tes" },
        { title: "core processor-00123", type: "cpu" },
      ],
    }
  ),
  createData(
    "STM32H750VBT6",
    "mcu",
    "	ic mcu 32bit 1MB flash 144 lqfp",
    "stmicroelectronics",
    11,
    {
      image: demoImg,
      features: [
        { title: "core processor-21", type: "arm" },
        { title: "core processor-11", type: "aet" },
        { title: "core processor-1", type: "tes" },
        { title: "core processor-00123", type: "cpu" },
      ],
    }
  ),
  createData(
    "STM32H750VBy7",
    "mcu",
    "	ic mcu 32bit 1MB flash 144 lqfp",
    "stmicroelectronics",
    11,
    {
      image: demoImg,
      features: [
        { title: "core processor-21", type: "arm" },
        { title: "core processor-11", type: "aet" },
        { title: "core processor-1", type: "tes" },
        { title: "core processor-00123", type: "cpu" },
      ],
    }
  ),
];
